export function initInScope($scope) {
    $('.js-display-dependent__field').on({
        change:function(){
            changeHandler($(this));
        }
    });
}

function changeHandler(field){
    console.log(field.attr('data-group'));
    console.log(field.val());
    $('.js-display-dependent__area').addClass('d-none').find('input').attr('disabled', 'disabled');
    $('.js-display-dependent__area[data-operator="equal"][data-group="'+field.attr('data-group')+'"][data-value="'+field.val()+'"]').removeClass('d-none').find('input').removeAttr('disabled');
    $('.js-display-dependent__area[data-operator="!equal"][data-group="'+field.attr('data-group')+'"][data-value!="'+field.val()+'"]').removeClass('d-none').find('input').removeAttr('disabled');
    $(window).trigger('resize');
}